import { DetailAction } from '../../detail/actions/DetailAction';
import { VodApi } from '../../../api/VodApi';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { Backend } from '../../../api/Backend';
import { CmsFilterCallback, CmsFilterData } from './CmsFilterTypes';
import { OptionData } from '../../../components/option/OptionData';
import { ICategoryV5 } from '../../../api/models/AndromeTV.types';
import { CmsProperty } from '../../../api/models/Shared.types';

export class CategoryCmsFilterAction extends DetailAction {
  private filter: CmsFilterData;
  private parent: string[];
  private _callback: CmsFilterCallback;
  private pageProperties: string[];

  constructor(
    backend: Backend,
    parent: string[],
    filter: CmsFilterData,
    pageProperties: string[],
    callback: CmsFilterCallback
  ) {
    super(backend);
    this.filter = filter;
    this.parent = parent;
    this._callback = callback;
    this.pageProperties = pageProperties;
  }

  override doAction() {
    const filter = {
      catalogId: this._backend.deviceProfile?.profile.catalog,
    };
    VodApi.vodCategories(this._backend, filter).then(data => {
      const options = this._categoryOptions(data);
      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
        },
      });
    });
  }

  optionSelected(option: OptionData) {
    this.filter.category = option;
    this._callback(this.filter);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  private _categoryOptions(data: ICategoryV5[]): OptionData[] {
    const items = this._findParentCategory(data);
    let allowAdult = false;
    if (
      this.pageProperties.includes(CmsProperty.AllowAdult) ||
      this.pageProperties.includes(CmsProperty.AdultRequired)
    ) {
      allowAdult = true;
    }
    const filteredItems = this._filterAdult(items, allowAdult);
    const parentTags = this.parent.slice();
    const activeItems = filteredItems.filter(cat => cat.activeCount > 0);
    return activeItems.map(cat => this._optionFromCategory(parentTags, cat));
  }

  private _optionFromCategory(parentTags: string[], cat: ICategoryV5): OptionData {
    const result: OptionData = { options: [], value: undefined };
    const hasChildren = cat.categories && cat.categories.length > 0;
    const postfix = hasChildren ? ' >' : '';
    result.text = cat.text.title + postfix;
    result.value = [...parentTags, cat.tag];
    if (hasChildren) {
      result.options = cat.categories ? cat.categories.map(c => this._optionFromCategory(result.value, c)) : [];
    }
    return result;
  }

  private _findParentCategory(data: ICategoryV5[]): ICategoryV5[] {
    let categories = data;
    for (let i = 0, n = this.parent.length; i < n; i++) {
      const item = categories.find(cat => cat.tag === this.parent[i]);
      if (item) {
        categories = item.categories ? item.categories : categories;
      }
    }
    return categories;
  }

  private _filterAdult(data: ICategoryV5[], adultAllowed = false) {
    if (adultAllowed) {
      return data;
    }
    const returnData: ICategoryV5[] = [];
    data.forEach(el => {
      if (!el.adult) {
        if (el.categories) {
          el.categories = this._filterAdult(el.categories, adultAllowed);
        }
        returnData.push(el);
      }
    });
    return returnData;
  }
}
